<template>
  <v-card class="mt-4 rounded-card card-shadow">
    <v-card-text class="text--primary">
      <v-row dense>
        <v-col cols="12" v-if="isMoedaEstrangeira">
          <px-moeda-chip :moeda="moeda"/>
        </v-col>
        <v-col cols="12" sm="4">
          <template v-if="isMoedaEstrangeira">
            <v-row dense no-gutters class="body-1">
              <v-col cols="6">
                Produtos:
              </v-col>
              <v-col cols="6" class="text-right">
                {{
                  finalizacao.totalProdutos |
                    currency(simboloMoeda, casaDecimal, configuracaoFormatacaoMoeda)
                }}
              </v-col>
              <v-col cols="6">
                Frete:
              </v-col>
              <v-col cols="6" class="text-right">
                {{
                  finalizacao.frete.totalTransporte |
                    currency(simboloMoeda, 2, configuracaoFormatacaoMoeda)
                }}
              </v-col>
              <v-col cols="6" class="font-weight-bold">
                Total:
              </v-col>
              <v-col cols="6" class="text-right">
                  <span class="text--primary--color font-weight-bold">
                    {{
                      finalizacao.total |
                        currency(simboloMoeda, casaDecimal, configuracaoFormatacaoMoeda)
                    }}
                  </span>
              </v-col>
            </v-row>
          </template>
        </v-col>
        <v-col cols="12" sm="4"></v-col>
        <v-col cols="12" sm="4">
          <v-row dense no-gutters class="body-1">
            <v-col cols="6">
              Produtos:
            </v-col>
            <v-col cols="6" class="text-right">
              {{ finalizacao.valorMoedaConvertido.totalProdutos | currency('R$', casaDecimal) }}
            </v-col>
            <v-col cols="6">
              Frete:
            </v-col>
            <v-col cols="6" class="text-right">
              {{ finalizacao.frete.totalTransporteConvertido | currency }}
            </v-col>
            <v-col cols="6" class="font-weight-bold">
              Total:
            </v-col>
            <v-col cols="6" class="text-right">
                  <span class="text--primary--color font-weight-bold">
                    {{ finalizacao.valorMoedaConvertido.total | currency('R$', casaDecimal) }}
                  </span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-data-table
        show-expand
        hide-default-footer
        disable-pagination
        :headers="headers"
        :items="finalizacao.produtos"
        item-key="id"
        class="elevation-0">
        <template v-slot:item.produto.descricao="{ item }">
          <v-tooltip top v-if="!isItemCancelado(item)">
            <template v-slot:activator="{ on }">
              <px-gestao-entrega-produto-situacao
                show-truck-icon
                :show-suffix-icon="false"
                :show-text="false"
                :situacao="item.situacaoEntrega"/>
            </template>
            <span>{{ tooltipItemEntregue(item.situacaoEntrega) }}</span>
          </v-tooltip>
          <px-produto-descricao
            :show-descricao-with-tooltip="false"
            :especificacao="item.especificacaoProdutoOrigem || item.especificacaoProduto"
            :produto="item.produto"/>&nbsp;
          <px-anexo v-if="item.arquivos && item.arquivos.length"
                    small read-only dot
                    v-model="item.arquivos"
                    :download-base-path="downloadFilePath"
          >
            <template v-slot:activator="{ on }">
              <v-btn small icon
                     v-on="on">
                <v-icon small>mdi-paperclip</v-icon>
              </v-btn>
            </template>
          </px-anexo>
          <v-chip label small v-if="isItemCancelado(item)"
                  class="ml-2"
                  color="error">
            Cancelado
          </v-chip>
          <div class="caption" v-if="codigoReferencia(item.produto)">
            Código fornecedor: {{ codigoReferencia(item.produto) }}
          </div>
        </template>
        <template v-slot:item.quantidade="{ item }">
          <span>
            {{ item.quantidade | number(getCurrencyFormat(item.produto.casasDecimais)) }}&nbsp;
          {{ item.unidadeMedida.descricao }}
          </span>
        </template>
        <template v-slot:item.precoUnitario="{ item }">
          <div>
            {{
              item.precoUnitario
                | currency(simboloMoeda,
                item.produto.casasDecimais,
                configuracaoFormatacaoMoeda)
            }}
            <div class="caption" v-if="isMoedaEstrangeira">
              {{
                item.valorMoedaConvertido.precoUnitario
                  | currency('R$', item.produto.casasDecimais)
              }}
            </div>
          </div>
        </template>
        <template v-slot:item.icms="{ item }">
          <px-imposto
            :imposto="item.impostos"
            :simbolo-moeda="simboloMoeda"
            :configuracao-moeda="configuracaoFormatacaoMoeda"
            tipo="ICMS"
            :show-aplicacao="false"
            :scale="item.produto.casasDecimais"/>
          <div v-if="isMoedaEstrangeira">
            <px-imposto
              class="caption"
              :imposto="item.impostos"
              show-valor-convertido
              tipo="ICMS"
              :show-aplicacao="false"
              :scale="item.produto.casasDecimais"/>
          </div>
        </template>
        <template v-slot:item.ipi="{ item }">
          <px-imposto
            :imposto="item.impostos"
            :simbolo-moeda="simboloMoeda"
            :configuracao-moeda="configuracaoFormatacaoMoeda"
            tipo="IPI"
            :show-aplicacao="false"
            :scale="item.produto.casasDecimais"/>
          <div v-if="isMoedaEstrangeira">
            <px-imposto
              class="caption"
              show-valor-convertido
              :imposto="item.impostos"
              tipo="IPI"
              :show-aplicacao="false"
              :scale="item.produto.casasDecimais"/>
          </div>
        </template>
        <template v-slot:item.total="{ item }">
          <div>
            {{
              item.total
                | currency(simboloMoeda,
                item.produto.casasDecimais,
                configuracaoFormatacaoMoeda)
            }}
            <div class="caption" v-if="isMoedaEstrangeira">
              {{ item.valorMoedaConvertido.total | currency('R$', item.produto.casasDecimais) }}
            </div>
          </div>
          <px-situacao-cotacao-produto :situacao="item.situacao"/>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="grey lighten-4 expanded-item">
            <v-row dense class="mt-3">
              <v-col cols="12" sm="4">
                <span class="caption font-weight-bold">Observação Externa</span>
                <div>
                  <px-show-large-text :large-text="observacaoExterna(item)"/>
                </div>
              </v-col>
              <v-col cols="12" sm="4">
                <span class="caption font-weight-bold">Código de refêrencia do fornecedor</span>
                <div>
                  {{ codigoReferencia(item.produto) | naoInformado }}
                </div>
              </v-col>
              <v-col cols="12" sm="4">
                <span class="caption font-weight-bold">{{ labelEspecificacao }}</span>
                <div>
                  <px-show-large-text :large-text="item.especificacaoProduto"/>
                </div>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="4">
                <span class="caption font-weight-bold">Data de faturamento</span>
                <div>
                  {{ item.dataFaturamento | date | naoInformado }}
                </div>
              </v-col>
              <v-col cols="12" sm="4">
                <span class="caption font-weight-bold">Prazo de entrega</span>
                <div>
                  {{ item.dataPrevisaoEntrega | date | naoInformado }}
                </div>
              </v-col>
              <v-col cols="12" sm="4">
                <span class="caption font-weight-bold">Finalidade da compra</span>
                <div v-if="item.finalidadeCompra">
                  <px-finalidade-compra-value :finalidade-compra="item.finalidadeCompra"/>
                </div>
                <div v-else>
                  Não informado
                </div>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="4" v-if="item.tipoNotaEntrada">
                <span class="caption font-weight-bold">Tipo de nota de entrada</span>
                <div>
                  <px-span-tooltip top
                      :text="notaEntrada(item.tipoNotaEntrada)"
                      :tooltip="item.tipoNotaEntrada.descricao"/>
                </div></v-col>
              <v-col cols="12" sm="4" v-if="item.cfop">
                <span class="caption font-weight-bold">CFOP da compra</span>
                <div>
                  <px-span-tooltip top
                      :text="cfop(item.cfop)"
                      :tooltip="`${item.cfop.codigo} - ${item.cfop.descricao}`"/>
                </div>
              </v-col>
              <v-col cols="12" sm="4" v-if="isFromCotacao">
                <span class="caption font-weight-bold">Especificação cotada</span>
                <div>
                  <px-show-large-text :large-text="item.especificacaoProdutoOrigem"/>
                </div>
              </v-col>
            </v-row>
          </td>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import Vue from 'vue';
import { OrigemCompra, SituacaoItemCompra, SituacaoEntregaCompra } from 'px-business-components';
import { CasaDecimalUtils, FornecedorProdutoUtils } from 'px-components';
import moedaMixin from '@/mixins/moeda-mixin';

export default {
  mixins: [moedaMixin],
  props: {
    finalizacao: Object,
    compraId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'Produto',
          sortable: false,
          value: 'produto.descricao',
          width: '500px',
        },
        {
          text: 'Quantidade',
          value: 'quantidade',
          sortable: false,
        },
        {
          text: 'Preço unitário',
          value: 'precoUnitario',
        },
        {
          text: 'ICMS',
          value: 'icms',
          sortable: false,
        },
        {
          text: 'IPI',
          value: 'ipi',
          sortable: false,
        },
        {
          text: 'Total',
          value: 'total',
        },
        {
          text: '',
          value: 'data-table-expand',
        },
      ],
    };
  },
  computed: {
    moeda() {
      return this.finalizacao.moeda;
    },
    cfop() {
      return cfop => `${cfop.codigo} - ${Vue.filter('truncate')(cfop.descricao, 20)}`;
    },
    notaEntrada() {
      return notaEntrada => Vue.filter('truncate')(notaEntrada.descricao, 20);
    },
    getCurrencyFormat() {
      return item => CasaDecimalUtils.getCurrencyFormat(item);
    },
    casaDecimal() {
      const mappedProdutos = this.finalizacao.produtos.map(produto => produto.produto);
      return CasaDecimalUtils.getCasaDecimal(mappedProdutos);
    },
    isFromCotacao() {
      return this.finalizacao.origemCompra === OrigemCompra.keys.COTACAO.key;
    },
    downloadFilePath() {
      return `external/pedidos/${this.compraId}/file`;
    },
    observacaoExterna() {
      return produto => produto.observacaoExterna ?? produto.produto.observacaoExterna;
    },
    labelEspecificacao() {
      return this.isFromCotacao ? 'Especificação fornecida' : 'Especificação do produto';
    },
    isItemCancelado() {
      return produto => produto.situacao === SituacaoItemCompra.keys.CANCELADO.key;
    },
    codigoReferencia() {
      return produto => FornecedorProdutoUtils
        .getCodigoReferenciaFornecedor(produto.fornecedoresProduto, this.finalizacao.fornecedor.id);
    },
    tooltipItemEntregue() {
      return situacao => (situacao ? SituacaoEntregaCompra.keys[situacao].description : '');
    },
  },
};
</script>
